<template>
<div class="rar" :class="showOverlay ? 'general-overlay' : ''">
    <vue-confirm-dialog></vue-confirm-dialog>
    <loading :active.sync="getLoader" :can-cancel="isFalse" is-full-page loader="dots" color="#2e3a6e" :height="128" :width="128"></loading>
    <router-view />
    <!-- <v-tour class="" name="web-tour" :callbacks="myCallbacks" :steps="getTour()" :options="{ highlight: true }">
        <template slot-scope="tour">
            <transition name="fade">
                <v-step v-for="(step, index) of tour.steps" :key="index" v-if="tour.currentStep === index" :step="step" :previous-step="tour.previousStep" :next-step="tour.nextStep" :stop="tour.stop" :skip="tour.skip" :is-first="tour.isFirst" :is-last="tour.isLast" :labels="tour.labels" :highlight="tour.highlight" style="background-color: #fff; color: #2E3B6D; margin-left: 50px; padding-left:70px; width: 300px">
                    <template>
                        <div slot="actions">
                            <button @click="tour.skip" class="text-red-500 mr-2">
                                Skip
                            </button>
                            <button @click="tour.previousStep" class="text-blue-500 mr-2">
                                Previous
                            </button>
                            <button @click="tour.nextStep" class="text-green-500">
                                Next
                            </button>
                        </div>
                    </template>
                </v-step>
            </transition>
        </template>
    </v-tour>

    <v-tour class="" name="mobile-tour" :callbacks="myCallbacks" :steps="getTour()" :options="{ highlight: true }">
        <template slot-scope="tour">
            <transition name="fade">
                <v-step v-for="(step, index) of tour.steps" :key="index" v-if="tour.currentStep === index" :step="step" :previous-step="tour.previousStep" :next-step="tour.nextStep" :stop="tour.stop" :skip="tour.skip" :is-first="tour.isFirst" :is-last="tour.isLast" :labels="tour.labels" :highlight="tour.highlight" style="background-color: #fff; color: #2E3B6D; margin-left: 50px; width: 300px">
                    <template>
                        <div slot="actions">
                            <button @click="tour.skip" class="text-red-500 mr-2">
                                Skip
                            </button>
                            <button @click="tour.previousStep" class="text-blue-500 mr-2">
                                Previous
                            </button>
                            <button @click="tour.nextStep" class="text-green-500">
                                Next
                            </button>
                        </div>
                    </template>
                </v-step>
            </transition>
        </template>
    </v-tour> -->
    <!-- <v-tour name="myTour" :steps="getTour()"></v-tour> -->
</div>
</template>

<script>
import {
    mapGetters,
    mapMutations,
    mapActions
} from "vuex";
import Loading from "vue-loading-overlay";
//import * as introJs from "intro.js";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios"
import {
    store
} from "@/store/store";
//import tour from "@/utils/tour.js";
export default {
    name: "App",
    components: {
        Loading,

    },
    data() {
        return {
            showOverlay: false,
            myCallbacks: {
                onSkip: this.hideOverlay,
                onFinish: this.hideOverlay,
            },
            loaderException: false,

            key: "",
        };
    },
    async mounted() {
        this.$Bus.$on("start-mobile-admin-tour", () => {
            this.key = "ADMIN_MOBILE_STEPS";
            this.showOverlay = true;
            const that = this;
            setTimeout(function () {
                that.$tours["mobile-tour"].start();
            }, 100);
        });
        this.$Bus.$on("start-admin-tour", () => {
            this.key = "ADMIN_WEB_STEPS";
            this.showOverlay = true;
            const that = this;
            setTimeout(function () {
                that.$tours["web-tour"].start();
            }, 100);
        });
        this.$Bus.$on("start-tenant-tour", () => {
            this.key = "TENANT_WEB_STEPS";
            this.showOverlay = true;
            const that = this;
            setTimeout(function () {
                that.$tours["web-tour"].start();
            }, 100);
        });
        this.$Bus.$on("start-mobile-tenant-tour", () => {
            this.key = "TENANT_MOBILE_STEPS";
            this.showOverlay = true;
            const that = this;
            setTimeout(function () {
                that.$tours["mobile-tour"].start();
            }, 100);
        });
        this.$Bus.$on("start-learner-tour", () => {
            this.key = "LEARNER_WEB_STEPS";
            this.showOverlay = true;
            const that = this;
            setTimeout(function () {
                that.$tours["web-tour"].start();
            }, 100);
        });
        this.$Bus.$on("start-mobile-learner-tour", () => {
            this.key = "LEARNER_MOBILE_STEPS";
            this.showOverlay = true;
            const that = this;
            setTimeout(function () {
                that.$tours["mobile-tour"].start();
            }, 100);
        });
        let url = window.location.href
        let prefix = new URL(url).host.split(".")[0]
        // prefix = !prefix.includes('localhost')  ? prefix : 'main';
          prefix = 'main';
        if(prefix === 'main' && Object.keys(this.getSettings).length === 0){
          await this.fetchTenantSettings({
            prefix: 'main'
          });

            // let res = await axios.get(process.env.VUE_APP_API + `/login-page-settings?uri=${prefix}`)
            // if (res.status === 200 && res.data.data.data.data_bypass) {
            //     const main_prefix = `web.${prefix}`;
            //     let remainder = new URL(url).pathname
            //     window.location.replace(`https://${main_prefix}.edclearn.com${remainder}`);
            // }
        }
    },
    methods:
    {
      ...mapActions(["fetchTenantSettings"]),
        hideOverlay() {
            this.showOverlay = false;
        },

        getTour() {
            return tour[this.key];
        },
        adminMobileTour() {
            var intro = introJs();
            intro.setOptions({
                steps: tour.ADMIN_MOBILE_STEPS,
            });
            intro.start();
        },
        adminWebTour() {
            var intro = introJs();
            intro.setOptions({
                steps: tour.ADMIN_WEB_STEPS,
            });
            intro.start();
        },
        tenantWebTour() {
            var intro = introJs();
            intro.setOptions({
                steps: tour.TENANT_WEB_STEPS,
            });
            intro.start();
        },
        tenantMobileTour() {
            var intro = introJs();
            intro.setOptions({
                steps: tour.TENANT_MOBILE_STEPS,
            });
            intro.start();
        },
        learnerWebTour() {
            var intro = introJs();
            intro.setOptions({
                steps: tour.LEARNER_WEB_STEPS,
            });
            intro.start();
        },
        learnerMobileTour() {
            var intro = introJs();
            intro.setOptions({
                steps: tour.LEARNER_MOBILE_STEPS,
            });
            intro.start();
        },
        ...mapActions(["updateToken"]),
        ...mapMutations(["updateLoader"]),
        notificationsPermisionRequest() {
            messaging
                .requestPermission()
                .then(() => {
                    messaging
                        .getToken()
                        .then((token) => {
                            if (token) {
                                const currentMessageToken = window.localStorage.getItem(
                                    "messagingToken"
                                );
                                if (currentMessageToken != token) {
                                    window.localStorage.setItem("messagingToken", token);
                                    this.updateToken({
                                        token
                                    });
                                }
                            } else {
                                console.log(
                                    "No InstanceId token available. Request Permission to generate one"
                                );
                                this.notificatioPermissionRequest();
                            }
                        })
                        .catch((err) => {
                            //console.log(err);
                        });
                })
                .catch((err) => {
                    //console.log("Unable to get permission to notify.", err);
                });
        },
        listenTokenRefresh() {
            const currentMessageToken = window.localStorage.getItem("messagingToken");
            if (!!currentMessageToken || currentMessageToken == null) {
                messaging.onTokenRefresh(function () {
                    messaging
                        .getToken()
                        .then(function (token) {
                            this.saveToken({
                                token
                            });
                        })
                        .catch(function (err) {
                            //console.log("Unable to retrieve refreshed token ", err);
                        });
                });
            }
        },
        async saveToken(payload) {
            try {
                window.localStorage.setItem("messagingToken", payload.token);
                this.updateToken({
                    token: payload.token
                });
                //console.log({ payload });
            } catch (err) {
                //console.log(err);
            }
        },
        getMessagingToken() {
            messaging
                .getToken()
                .then((token) => {
                    if (token) {
                        const currentMessageToken = window.localStorage.getItem(
                            "messagingToken"
                        );
                        if (currentMessageToken != token) {
                            // dispatch("saveToken", { token });
                        }
                    } else {
                        console.log(
                            "No InstanceId token available. Request Permission to generate one"
                        );
                        this.notificatioPermissionRequest();
                    }
                })
                .catch((err) => {
                    //console.log(err);
                });
        },
    },
    computed: {
        ...mapGetters(["getLoader","getSettings"]),

        isFalse() {
            return false;
        },
    },




};
</script>

<style lang="scss">
@import "@/scss/main";

.text-main-color {
    color: color(lms-admin) !important;
}

.tenant-main-color {
    color: color(lms-tenant) !important;
}

.tenant-main-bg {
    background-color: color(lms-tenant);
}

.rotate {
    transform: rotate(-180deg);
}

.modal-field {
    color: color(lms-tenant) !important;
}

.introjs-nextbutton {
    background: #2bc63d !important;
    padding: 0.65rem !important;
    margin: 10px !important;
    text-shadow: 0 0 0 #fff !important;
    color: white !important;
    border: 0 !important;
}

.introjs-prevbutton {
    background: #0984e3 !important;
    padding: 0.65rem !important;
    margin: 10px !important;
    text-shadow: 0 0 0 #fff !important;
    color: white !important;
    border: 0 !important;
}

.introjs-helperLayer {
    background-color: rgb(253, 251, 251, 0.2) !important;
}

.introjs-skipbutton {
    background: red !important;
    padding: 0.65rem !important;
    margin: 10px !important;
    text-shadow: 0 0 0 #fff !important;
    color: white !important;
    border: 0 !important;
}

.introjs-helperNumberLayer {
    display: none !important;
}

.introjs-bullets {
    display: none;
}

.introjs-fixedTooltip {
    position: absolute;
    height: 100vh;
}

.introjs-fixParent {
    position: static;
}

.introjs-helperLayer {
    background: transparent;
    height: 100vh;
}

.introjs-overlay {
    opacity: 0 !important;
    height: 100vh;
}

.introjs-helperLayer:before {
    opacity: 0;
    content: "";
    position: fixed;
    width: inherit;
    height: inherit;
    border-radius: 0.5em;
    box-shadow: 0 0 0 1000em rgba(0, 0, 0, 0.7);
    opacity: 1;
}

.introjs-helperLayer:after {
    content: "";
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: fixed;
    z-index: 1000;
}

/*

.main-tenant-color {
  color: color(lms-tenant) !important;
}

.course-color {
  color: color(lms-course-mini) !important;
}

.single-course-content {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 27px;
}

.single-course-title {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 36px;
  letter-spacing: 0.4px;
}
.tenant-bg-color {
  background-color: color(tenant-bg-color) !important;
}

.tab-heading {
  background-color: color(lms-admin);

  .active-tab {
    color: color(lms-admin) !important;
    background-color: #fff !important;
    padding: 1em;
  }
}*/

.general-overlay {
    background: #b1b3b9;
    opacity: 0.8;
    z-index: 0;
}
</style>
